// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","tooltipContainer":"j2+ycTnHgzmS","tooltipSubText":"TvtAWxXdIU96","tooltipText":"_6F5J-xd-MgzA"};